import { render, staticRenderFns } from "./PageTeacherVideoConference.vue?vue&type=template&id=6233b234&scoped=true&"
import script from "./PageTeacherVideoConference.vue?vue&type=script&lang=js&"
export * from "./PageTeacherVideoConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6233b234",
  null
  
)

export default component.exports